import { HttpClient, RequestParams } from "@/utils/http-client";
import { CourseType } from "./Courses";
import { ProductType } from "./Products";

export interface NewsListParamsType {
  title?: string;
  description?: string;
  limit?: number;
  offset?: number;
  type?: string;
  /** @format date */
  end_time_to?: string;
  /** @format date */
  end_time_from?: string;
  /**
   * start_time_from, has a priority above start_time_to (excluding the last)
   * @format date
   */
  start_time_from?: string;
  /** @format date */
  start_time_to?: string;
  course_id?: number;
}

interface NewsLinksType {
  is_external?: boolean;
  title?: string;
  url?: string;
}

export enum NewsTypeType {
  Announcement = "announcement",
  Feature = "feature",
  Banner = "banner",
  MediaBanner = "media_banner",
}

export interface NewsType {
  /** Course model */
  course?: CourseType;
  /** @format int64 */
  course_id?: number;
  /** @format date-time */
  created_at?: string;
  /** @format int64 */
  creator_id?: number;
  description?: string;
  /** @format date-time */
  end_time?: string;
  /** @format int64 */
  id?: number;
  image?: string;
  links?: NewsLinksType[];
  /** @format date-time */
  modified_at?: string;
  /** @format int64 */
  priority?: number;
  /** @format date-time */
  start_time?: string;
  title?: string;
  type?: NewsTypeType;
  product?: ProductType;
}

export class News<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns courses list by filter, with limit/offset pagination, and total count in header
   *
   * @tags news
   * @name NewsList
   * @summary Get list of news by filter
   * @request GET:/news
   * @secure
   * @response `200` `(NewsType)[]` News list
   * @response `500` `void` error
   */
  newsList = (query: NewsListParamsType, params: RequestParams = {}) =>
    this.request<NewsType[], void>({
      path: `/news`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
